var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavIconGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.83621 12.2781C5.46908 11.4315 4.19841 10.4383 3.04676 9.31601C2.23281 8.50277 1.61317 7.51613 1.23415 6.42975C0.55836 4.31397 1.34784 1.89504 3.57098 1.18136C4.14699 0.996464 4.7589 0.952122 5.35553 1.05211C5.95217 1.1521 6.51617 1.39349 7.00043 1.75608C7.48396 1.39451 8.04688 1.1537 8.64231 1.05373C9.23775 0.953757 9.84845 0.99753 10.4236 1.18136C12.6467 1.89504 13.4425 4.33924 12.7667 6.42975C12.3895 7.51699 11.7696 8.50401 10.9541 9.31601C9.80244 10.4383 8.53177 11.4315 7.16464 12.2781L7.01307 12.3665L6.83621 12.2781Z",
    stroke: "#097E52",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.34985 3.56213C9.68017 3.66797 9.97138 3.86994 10.1863 4.14221C10.4012 4.41448 10.53 4.74467 10.5561 5.09053",
    stroke: "#097E52",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavIconGreen);
export default __webpack_public_path__ + "static/media/favIconGreen.47cd796e9b7c6f1b2241da67fd77b2df.svg";
export { ForwardRef as ReactComponent };